export default "__VITE_ASSET___80kiPin__"